var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.141,
    height: 21.141,
    viewBox: "0 0 21.141 21.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(-340.255 -68.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(336.88 65.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M24.17,17.228a1.231,1.231,0,0,1,.168-.62,1.711,1.711,0,0,1,.107-.158,8.234,8.234,0,0,0,1.4-4.589A8.645,8.645,0,0,0,17.02,3.375a8.766,8.766,0,0,0-8.654,6.754,8.167,8.167,0,0,0-.188,1.738,8.62,8.62,0,0,0,8.69,8.593,10.466,10.466,0,0,0,2.4-.391c.574-.158,1.143-.366,1.291-.422a1.344,1.344,0,0,1,.473-.086,1.321,1.321,0,0,1,.513.1l2.881,1.021a.687.687,0,0,0,.2.051.4.4,0,0,0,.407-.407A.653.653,0,0,0,25,20.191Z",
    transform: "translate(-1.331 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M17.121,23.523c-.183.051-.417.107-.671.163a9.379,9.379,0,0,1-1.728.229,8.62,8.62,0,0,1-8.69-8.593,9.608,9.608,0,0,1,.076-1.088c.03-.219.066-.437.117-.65.051-.229.112-.457.178-.681L6,13.263A7.563,7.563,0,0,0,3.375,18.95a7.478,7.478,0,0,0,1.26,4.167c.117.178.183.315.163.407s-.6,3.151-.6,3.151a.408.408,0,0,0,.137.391.414.414,0,0,0,.259.091.365.365,0,0,0,.147-.03L7.588,26a.794.794,0,0,1,.29-.056.8.8,0,0,1,.32.066,8.553,8.553,0,0,0,3.085.61,7.981,7.981,0,0,0,6.1-2.8s.163-.224.351-.488C17.548,23.4,17.335,23.468,17.121,23.523Z",
    transform: "translate(0 -2.641)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7aa5f581a4c1bc22f58a8763d71b9426.svg";
export { ForwardRef as ReactComponent };